export const FLOW_NAMES = {
  E2E: 'e2e'
}

export const FLOW_STATES = {
  NEW: 'NEW',
  CLAIM_DETAILS: 'CLAIM_DETAILS',
  PROCESSED: 'PROCESSED',
  PROCESSED_OK: 'PROCESSED_OK',
  PROCESSED_KO: 'PROCESSED_KO',
  PROCESSED_ERROR: 'PROCESSED_ERROR',
  DAMAGES: 'DAMAGES',
  GAG_DETAILS: 'GAG_DETAILS',
  BILLMA: 'BILLMA',
  REN_DETAILS: 'REN_DETAILS',
  SMART: 'SMART',
  COMPENSATION_TYPE: 'COMPENSATION_TYPE',
  COMPENSATION_MOBILIER: 'COMPENSATION_MOBILIER',
  COMPENSATION_MOBILIER_PROCESSED_OK: 'COMPENSATION_MOBILIER_PROCESSED_OK',
  COMPENSATION_MOBILIER_PROCESSED_KO: 'COMPENSATION_MOBILIER_PROCESSED_KO',
  WAITING_ROOM: 'WAITING_ROOM',
  NEW_CONTACT: 'NEW_CONTACT',
  MANUAL_REVIEW: 'MANUAL_REVIEW'
}

export const FLOW_TRANSITIONS = {
  SHOW_DETAILS: 'SHOW_DETAILS',
  ADD_DAMAGES: 'ADD_DAMAGES',
  SHOW_COMPENSATION_TYPE: 'SHOW_COMPENSATION_TYPE',
  SHOW_MOBILIER: 'SHOW_MOBILIER',
  SHOW_GAG_RESUME: 'SHOW_GAG_RESUME',
  SHOW_REN_RESUME: 'SHOW_REN_RESUME',
  SHOW_BILLMA: 'SHOW_BILLMA',
  // FINISHED: 'FINISHED',
  FINISHED_OK: 'FINISHED_OK',
  FINISHED_KO: 'FINISHED_KO',
  FINISHED_ERROR: 'FINISHED_ERROR',
  MOBILIER_FINISHED_OK: 'MOBILIER_FINISHED_OK',
  MOBILIER_FINISHED_KO: 'MOBILIER_FINISHED_KO'
}
